import { IOrder, IOrderCancelInput } from "@/interfaces/order.interfaces";
import { OrdersFiltersMessages } from "@/messages/orders/order-filters.messages";
import { OrdersTableMessages } from "@/messages/orders/orders-table.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";
import { OrderStatus } from "@/types/order.types";

import { OrderFilterKey } from "./types";

export const ORDERS_TABLE_COLUMNS = (messages: OrdersTableMessages) => {
  return [
    messages.orderNumberColumn,
    messages.dateColumn,
    messages.buyerColumn,
    messages.orderAmount,
    messages.salesChannelColumn,
    messages.statusColumn,
    messages.optionsColumn,
  ];
};

export const ORDER_FILTER_OPTIONS = (
  messages: OrdersFiltersMessages
): SelectData<OrderFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.orderNumberOption, value: "orderNumber" },
  { label: messages.dateOption, value: "orderDate" },
  { label: messages.buyerOption, value: "billingName" },
  { label: messages.salesChannelOption, value: "salesChannel" },
  { label: messages.statusOption, value: "orderStatus" },
  { label: messages.skuOption, value: "sku" },
];

export const ORDER_FILTER_ATTRIBUTES: Partial<Record<OrderFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  orderNumber: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  salesChannel: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  billingName: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  orderStatus: {
    defaultValue: OrderStatus.Confirmed,
    type: FilterType.Equals,
    valueType: "options",
  },
  orderDate: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "date",
  },
  sku: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
};

export const ORDER_STATUS = (messages: OrdersFiltersMessages): SelectData<OrderStatus>[] => {
  return [
    { value: OrderStatus.Waiting, label: messages.waitingOption },
    { value: OrderStatus.Error, label: messages.errorOption },
    { value: OrderStatus.Confirmed, label: messages.confirmedOption },
    { value: OrderStatus.Paid, label: messages.paidOption },
    { value: OrderStatus.Handling, label: messages.handlingOption },
    { value: OrderStatus.Invoiced, label: messages.invoicedOption },
    { value: OrderStatus.Shipped, label: messages.shippedOption },
    { value: OrderStatus.Delivered, label: messages.deliveredOption },
    { value: OrderStatus.Cancelled, label: messages.cancelledOption },
    { value: OrderStatus.CancellationRequest, label: messages.cancellationRequestOption },
  ];
};

export const ORDER_FILTER_OPTION_VALUES = (
  messages: OrdersFiltersMessages
): Partial<Record<OrderFilterKey, SelectData<FilterValue>[]>> => ({
  orderStatus: ORDER_STATUS(messages),
});

export const initialFilterValues: IFilter<IOrder>[] = [];

export function normalizeCancelOrderData(order: IOrder): IOrderCancelInput {
  return {
    orderDetail: {
      orderNumber: String(order.orderNumber),
      customerPlatformId: order.customerPlatformId,
    },
    cancelationDate: new Date(),
    fraudRisk: !!order.fraudRisk,
  };
}

export const fixedExcludeQuotationFilter: IFilter<IOrder> = {
  property: "orderStatus",
  value: "W",
  filterType: FilterType.NotEquals,
};
